var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.949 18.293C14.8657 18.293 12.8074 17.8388 10.774 16.9305C8.74069 16.0221 6.89069 14.7346 5.22402 13.068C3.55736 11.4013 2.26986 9.5513 1.36152 7.51797C0.45319 5.48464 -0.000976562 3.4263 -0.000976562 1.34297C-0.000976562 1.04297 0.0990234 0.792969 0.299023 0.592969C0.499023 0.392969 0.749023 0.292969 1.04902 0.292969H5.09902C5.33236 0.292969 5.54069 0.372135 5.72402 0.530469C5.90736 0.688802 6.01569 0.876302 6.04902 1.09297L6.69902 4.59297C6.73236 4.85964 6.72402 5.08464 6.67402 5.26797C6.62402 5.4513 6.53236 5.60964 6.39902 5.74297L3.97402 8.19297C4.30736 8.80964 4.70319 9.40547 5.16152 9.98047C5.61986 10.5555 6.12402 11.1096 6.67402 11.643C7.19069 12.1596 7.73236 12.6388 8.29902 13.0805C8.86569 13.5221 9.46569 13.9263 10.099 14.293L12.449 11.943C12.599 11.793 12.7949 11.6805 13.0365 11.6055C13.2782 11.5305 13.5157 11.5096 13.749 11.543L17.199 12.243C17.4324 12.3096 17.624 12.4305 17.774 12.6055C17.924 12.7805 17.999 12.9763 17.999 13.193V17.243C17.999 17.543 17.899 17.793 17.699 17.993C17.499 18.193 17.249 18.293 16.949 18.293ZM3.02402 6.29297L4.67402 4.64297L4.24902 2.29297H2.02402C2.10736 2.9763 2.22402 3.6513 2.37402 4.31797C2.52402 4.98464 2.74069 5.64297 3.02402 6.29297ZM11.974 15.243C12.624 15.5263 13.2865 15.7513 13.9615 15.918C14.6365 16.0846 15.3157 16.193 15.999 16.243V14.043L13.649 13.568L11.974 15.243Z",
    fill: "url(#paint0_linear_401_704)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_401_704",
    x1: -0.327557,
    y1: 9.67058,
    x2: 18.2924,
    y2: 9.67058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#895EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F03063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.83d96e62c053b12cf0dff62788e36c40.svg";
export { ForwardRef as ReactComponent };